<template>
  <div>
    <div class="wrap">
      <!-- 面包屑下标题 -->
      <!-- <div class="wrap-title">
        <span class="wrap-title-text">
          <slot name="title">{{ title }}</slot>
        </span>
      </div> -->
    </div>
    <!-- header -->
    <div class="wrap-header">
      <slot name="header"></slot>
      <slot name="button"></slot>
    </div>

    <!-- container-->
    <div class="wrap-cont">
      <div class="wrap-cont-cover">
        <div class="wrap-container">
          <!-- 默认插槽 -->
          <slot></slot>
        </div>
      </div>
    </div>

    <!-- footer -->
    <div class="wrap-footer bg-white" :class="{'footerStyle':footerStyle}">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "contentComponent",
  zh: "页面内容通用组件",
  data() {
    return {
      title: "",
      footerStyle: false
    };
  },
  watch: {
    $route(route) {
      this.title = route.meta.title || route.meta.name;
    }
  },
  mounted() {
    this.title = this.$route.meta.title || this.$route.meta.name;
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.route-nesting {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.wrap {
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;

  &-title {
    padding: 0 32px 24px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &-text {
      @include pxAndLh(20);
      color: $text-color-black-85;
      font-weight: bold;
    }
  }

  &-header {
    background: #fff;
    padding: 0 16px 16px;
    border-bottom: 1px solid #e1e1e1;
  }

  &-cont {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 24px 0;

    &-cover {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 24px 0;
    }
  }

  &.default &-container {
    background: #fff;
  }

  &-container {
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  &-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    text-align: right;
    border-top: 1px solid #eee;
  }
}
.wrap-header {
  >:not(.not-default-form) {
    .ant-form-item {
      margin-bottom: 16px;
      margin-left: 8px;
      margin-right: 0;
      .ant-form-item-control-wrapper {
        width: 282px;
      }
      .ant-form-item-label {
        width: 96px;
      }
      .ant-calendar-picker-input {
        padding: 4px 6px;
      }
      .ant-calendar-range-picker-input {
        width: 45%;
      }
      .ant-calendar-range-picker-separator {
        width: 7px;
      }
    }
    .ant-form-item-label {
      width: 84px;
    }
    .range-input {
        width: calc(50% - 20px);
        text-align: center;
        &-right {
            border-left: 0;
        }
    }
    &-button {
      width: 378px;
      .ant-form-item-control-wrapper {
        float: right;
        .ant-form-item-control {
          text-align: right;
        }
      }
    }
  }
}

.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
.footerStyle {
  padding-left: 64px;
}
.card {
  margin-top: -48px;
}
.in_title {
    // height: 40px;
    line-height: 40px;
    margin-bottom: 16px;
    background: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.65);
    padding-left: 16px;
    a {
        float: right;
        margin-right: 16px;
    }
    .anticon-info-circle {
        padding-right: 8px;
        color: #FFBF00;
        margin-top: 2px;
    }
}
</style>
